module.exports = __webpack_public_path__ + "img/195.86867d65.jpg";